import { Activity, Bike, Dumbbell, Footprints, HeartPulse, Move, PersonStanding, StretchHorizontal, Target, Timer, Zap } from "lucide-react";
import { SoccerBallIcon } from "../components/SoccerBallIcon";

// Persist only these stable identifiers, never SVG or arbitrary component names.
export const TRAINING_LIBRARY_ICONS = Object.freeze([
  { id: "training", Icon: Activity, de: "Allgemeines Training", en: "General training" },
  { id: "football", Icon: SoccerBallIcon, de: "Fußball", en: "Football" },
  { id: "running", Icon: Footprints, de: "Laufen", en: "Running" },
  { id: "strength", Icon: Dumbbell, de: "Kraft", en: "Strength" },
  { id: "mobility", Icon: PersonStanding, de: "Mobility", en: "Mobility" },
  { id: "stretching", Icon: StretchHorizontal, de: "Stretching", en: "Stretching" },
  { id: "foam-roll", Icon: Move, de: "Faszienrolle", en: "Foam rolling" },
  { id: "sprint", Icon: Zap, de: "Sprint", en: "Sprint" },
  { id: "tennis", Icon: Target, de: "Tennis", en: "Tennis" },
  { id: "cycling", Icon: Bike, de: "Fahrrad", en: "Cycling" },
  { id: "coordination", Icon: Timer, de: "Koordination", en: "Coordination" },
  { id: "recovery", Icon: HeartPulse, de: "Recovery", en: "Recovery" },
]);

export function getTrainingLibraryIcon(id) {
  const aliases = { dumbbell: "strength", foam_roller: "foam-roll", bike: "cycling", activity: "training", target: "coordination", footprints: "running", heart: "recovery", wind: "recovery", leaf: "recovery", sidestep: "coordination", soccer: "football", "move-horizontal": "coordination", "refresh-cw": "recovery", users: "football" };
  return TRAINING_LIBRARY_ICONS.find((entry) => entry.id === (aliases[id] || id))?.Icon || Activity;
}

export function trainingLibraryText(item, field = "title", lang = "de") {
  return (lang === "en" && item?.[`${field}_en`]) || item?.[field] || "";
}

export function isSystemTrainingTemplate(item) {
  return item?.source === "system" || item?.is_system === true || item?.system === true || !!item?.system_template_id;
}
